<template>
  <div class="team-report-result-individual-intro">
    <div class="team-report-result-individual-intro__intro">
      <i18n-t keypath="pdfReport.individualpage1_heading" :locale="lang" tag="h2"></i18n-t>
      <i18n-t keypath="pdfReport.individualpage1_desc" :locale="lang" tag="p"></i18n-t>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lang: ''
  }
}
</script>

<style scoped>
* {
  letter-spacing: initial!important;
}
h2 {
  font-size: 20px!important;
  margin: 0 0 4px 0!important;
  padding: 0!important;
  color: #000000;
}
h3 {
  font-size: 14px!important;
  margin: 16px 0 8px 0!important;
  padding: 0!important;
  color: #000000;
}
p,
p strong {
  font-size: 10px!important;
  margin: 0!important;
  padding: 0!important;
  max-width: 460px;
  color: #000000;
}
.team-report-result-individual-intro__intro {
  width: 460px;
}
</style>
